<template>

    <div>
        <Delivery
            v-if="entity.id"
            :entity-type="BUSINESS_TYPE.ENTITY"
            :entity-id="+entity.id"
        >
            <template v-slot:tabs>
                <EntityTabLinks />
            </template>
        </Delivery>
    </div>

</template>

<script>
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import Delivery from '@/components/delivery/Delivery';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityDelivery',

        components: {
            Delivery,
            EntityTabLinks
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/entities/get/${id}`)).data;
        },

        methods: {}
    }
</script>
